export default __webpack_public_path__ + "static/media/edit-2.e528cffc.svg";